import React, { useState } from 'react'
import I18n from 'i18n'
import ComplianceChart from './ComplianceChart'
import { useResearchDashboardMetricsQuery } from '../../../../backend/Queries'

export default function WatchWeartimeComplianceChart (): React.ReactElement {
  type WeartimePeriod = 'daily' | 'weekly' | 'monthly'
  const [period, setPeriod] = useState<WeartimePeriod>('daily')
  const [offset, setOffset] = useState(0)
  const { data, isLoading } = useResearchDashboardMetricsQuery(period, offset)

  const changePeriod = (newPeriod: WeartimePeriod): void => {
    setPeriod(newPeriod)
    setOffset(0)
  }

  const periodToggle = (
    <div className='rd-period-toggle' style={{ flexShrink: 0, flexWrap: 'nowrap' }}>
      <button
        className={`rd-toggle-btn ${period === 'daily' ? 'active' : ''}`}
        onClick={() => changePeriod('daily')}
      >
        {I18n.t('components.dashboards.research_dashboard.charts.toggle_daily')}
      </button>
      <button
        className={`rd-toggle-btn ${period === 'weekly' ? 'active' : ''}`}
        onClick={() => changePeriod('weekly')}
      >
        {I18n.t('components.dashboards.research_dashboard.charts.toggle_weekly')}
      </button>
      <button
        className={`rd-toggle-btn ${period === 'monthly' ? 'active' : ''}`}
        onClick={() => changePeriod('monthly')}
      >
        {I18n.t('components.dashboards.research_dashboard.charts.toggle_monthly')}
      </button>
    </div>
  )

  const titleKey = period === 'daily'
    ? 'compliance_watch_weartime'
    : `compliance_${period}_watch_weartime`

  return (
    <ComplianceChart
      title={I18n.t(`components.dashboards.research_dashboard.charts.${titleKey}`)}
      data={data?.watchWeartime}
      color='#4caf50'
      isLoading={isLoading}
      offset={offset}
      onOffsetChange={setOffset}
      periodToggle={periodToggle}
      currentWeekLabel={offset === 0 ? data?.watchWeartime?.history?.[data.watchWeartime.history.length - 1]?.label : undefined}
    />
  )
}
